var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.66666667,8.91666667 L5.91666667,8.91666667 L5.91666667,7.16666667 L4.75,7.16666667 L4.75,8.91666667 L3,8.91666667 L3,10.0833333 L4.75,10.0833333 L4.75,11.8333333 L5.91666667,11.8333333 L5.91666667,10.0833333 L7.66666667,10.0833333 L7.66666667,8.91666667 L7.66666667,8.91666667 Z M13.5,9.5 C14.4683333,9.5 15.2441667,8.71833333 15.2441667,7.75 C15.2441667,6.78166667 14.4683333,6 13.5,6 C13.3133333,6 13.1325,6.02916667 12.9691667,6.08166667 C13.3016667,6.55416667 13.4941667,7.12583333 13.4941667,7.75 C13.4941667,8.37416667 13.2958333,8.94 12.9691667,9.41833333 C13.1325,9.47083333 13.3133333,9.5 13.5,9.5 L13.5,9.5 Z M10.5833333,9.5 C11.5516667,9.5 12.3275,8.71833333 12.3275,7.75 C12.3275,6.78166667 11.5516667,6 10.5833333,6 C9.615,6 8.83333333,6.78166667 8.83333333,7.75 C8.83333333,8.71833333 9.615,9.5 10.5833333,9.5 L10.5833333,9.5 Z M14.445,10.76 C14.9291667,11.1858333 15.25,11.7283333 15.25,12.4166667 L15.25,13.5833333 L17,13.5833333 L17,12.4166667 C17,11.5183333 15.6175,10.9641667 14.445,10.76 L14.445,10.76 Z M10.5833333,10.6666667 C9.41666667,10.6666667 7.08333333,11.25 7.08333333,12.4166667 L7.08333333,13.5833333 L14.0833333,13.5833333 L14.0833333,12.4166667 C14.0833333,11.25 11.75,10.6666667 10.5833333,10.6666667 L10.5833333,10.6666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Team",
    transform: "translate(-3.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#fff",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamWhite);
export default __webpack_public_path__ + "static/media/team-white.97ccce1617ed82a66fedb943e5ceb246.svg";
export { ForwardRef as ReactComponent };